import React, { useEffect, useState, useRef } from 'react';
import { CircularProgress } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { formatDateToDisplay } from '../../utils';
import { songsServices } from '../../services';
import { songsStore } from '../../store';
import { songActions } from '../../actions';
import useClickOutside from '../../utils/useClickOutside';
import PlayBtn from '../../assets/play_btn.svg';
import SongPlayer from '../../components/SongPlayer';

function EditPlaylistServer({ playlistType, searchInput }) {
  const LIMIT = 10;
  const [serverSongs, setServerSongs] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState({ page: 1, isLast: false });
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Zustand Store
  const { addSongList, songs, addSingleSong, removeSingleSong, setSongs } = songsStore((state) => {
    return {
      setCurrSongToPlay: state.setCurrSongToPlay,
      currentSong: state.currSongToPlay,
      songs: state.songs,
      addSongList: state.addSongList,
      addSingleSong: state.addSong,
      removeSingleSong: state.removeSong,
      setSongs: state.setSongs,
    };
  });

  const handleAllSongsCheck = (event) => {
    if (event.target.checked) {
      const mergedSongs = [...serverSongs, ...songs];

      const filteredSongs = mergedSongs.filter((obj) => {
        if (songs.some((song) => song.id === obj.id)) {
          return false;
        } else {
          return true;
        }
      });

      addSongList(filteredSongs);
    } else {
      setSongs([]);
    }
  };

  const handleSingleSongCheck = (event, song) => {
    if (songs.some((item) => item.id === song.id)) {
      removeSingleSong(song);
      setChecked(false);
    } else {
      addSingleSong(song);
      setChecked(true);
    }
  };

  const [isSongDialogOpen, setIsSongDialogOpen] = useState({
    isOpen: false,
    id: 0,
  });
  const [songDetail, setSongDetail] = useState({});

  const toolTipRef = useRef(null);
  useClickOutside(toolTipRef, () => {
    setIsSongDialogOpen({
      isOpen: false,
      id: 0,
    });
  });

  const toolTipRefs = useRef(null);
  const onPlayClick = (song, index) => {
    setSongDetail({
      song_name: song.title || '',
      artist_name: song.artist_name || '',
      songgenre: song.genre || [],
      description: song.description || '',
      thumbnail_img: song.thumbnail_img || '',
      license: song.license_name || '',
      termsandconditions: song.tc_sign || '',
      created_by: song.created_by || '',
      creator_id: song.creator_id || '',
      plan: song.plan || [],
      audio_track: song.audio_track || '',
    });

    setIsSongDialogOpen({
      id: index,
      isOpen: true,
    });
  };

  useEffect(() => {
    // Fetch First 10 Songs

    const fetchAllSongs = async () => {
      // reset the page to 1
      setCurrentPage({ page: 1, isLast: false });
      //
      const response = await songsServices.fetchAllSongs({
        page: 1,
        limit: LIMIT,
        search: searchInput,
        status: 'ACTIVE',
        plan: [playlistType],
        submission_status: 'ACCEPTED',
      });

      // if (response?.data?.data?.length > 0) {
      setServerSongs([...response?.data?.data]);
      setTableLoading(false);
      // }

      if (response?.data?.data?.length < LIMIT) {
        setTableLoading(false);
        setCurrentPage({ ...currentPage, isLast: true });
      }
    };

    fetchAllSongs();
  }, [searchInput]);

  const fetchNextSetOfSongs = async () => {
    // return;
    const response = await songsServices.fetchAllSongs({
      page: currentPage.page + 1,
      limit: LIMIT,
      search: searchInput,
      status: 'ACTIVE',
      plan: [playlistType],
    });

    if (response?.data?.data?.length > 0) {
      setServerSongs([...serverSongs, ...response?.data?.data]);
      setTableLoading(false);
    }

    const newPage = currentPage.page + 1;
    const isLast = response?.data?.data?.length < LIMIT;

    if (isLast) setTableLoading(false);

    setCurrentPage({ page: newPage, isLast });
  };

  // Detect When user scroll to bottom of table
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && !currentPage.isLast) {
      setTableLoading(true);
      fetchNextSetOfSongs();
    }
  };

  return (
    <div style={{ display: 'flex', width: '100%', height: '100%', overflow: 'hidden' }}>
      <TableContainer className="tbl_wraper tbl_wrap" style={{ border: '1px solid #40189D' }} component={Paper} onScroll={handleScroll}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell className="checkbox">
                <Checkbox inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} onChange={handleAllSongsCheck} />
              </TableCell>
              <TableCell className="result" style={{ paddingLeft: 15, paddingRight: 5 }}>
                Result
              </TableCell>
              <TableCell>Song Name</TableCell>
              <TableCell>Artist Name</TableCell>
              <TableCell>Date</TableCell>
              <TableCell className="action">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {serverSongs?.map((row, index) => (
              <TableRow key={row.id}>
                <TableCell className="checkbox">
                  <Checkbox
                    onChange={(event) => handleSingleSongCheck(event, row)}
                    inputProps={{ 'aria-label': 'uncontrolled-checkbox' }}
                    name="song"
                    checked={songs.some((song) => song.id === row.id)}
                  />
                </TableCell>
                <TableCell className="result" style={{ paddingLeft: 15, paddingRight: 5 }}>
                  #{++index}
                </TableCell>
                <TableCell className="table-name-cell">{row.title}</TableCell>
                <TableCell>{row.artist_name}</TableCell>
                <TableCell>{formatDateToDisplay(row.created_at)}</TableCell>
                <TableCell className="action">
                  <Grid item ref={toolTipRefs?.current?.[index]} className="tooltip-wrapper">
                    <img
                      src={PlayBtn}
                      onClick={() => {
                        onPlayClick(row, index);
                      }}
                      alt=""
                    />
                    {isSongDialogOpen.isOpen && isSongDialogOpen.id === index && (
                      <SongPlayer
                        songDetail={songDetail}
                        onClose={() => {
                          setIsSongDialogOpen({
                            id: 0,
                            isOpen: false,
                          });
                        }}
                      />
                    )}
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
            {tableLoading && (
              <tr style={{ textAlign: 'center', width: '100%', height: 70 }}>
                <td></td>
                <td></td>
                <td>
                  <CircularProgress />
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
export default EditPlaylistServer;

